import React from 'react';
import AutoCompleteField from './AutoCompleteField';

class AutoCompleteAddressField extends AutoCompleteField {
  autoCompleteOptionType = ['address'];
}

export default React.forwardRef((props, ref)=> <AutoCompleteAddressField innerRef={ref} {...props} />)